import { api } from "@/lib/api";

export const SEEN_KEY = "lf_news_seen";
export const TAGS = { feature: ["New feature", "#10B981"], update: ["Update", "#60A5FA"], announcement: ["Announcement", "#F59E0B"], event: ["Event", "#C084FC"] };
export const STAGES = { planned: ["Planned", "#A8A090"], in_progress: ["In progress", "#60A5FA"], almost: ["Almost there", "#10B981"] };
export const imgUrl = (id) => (id ? `/api/site/images/${id}` : null);
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" }) : "");

export const uploadSiteImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return (await api.post("/admin/site/images", fd)).data;
};
